import { render, staticRenderFns } from "./BotaoCancelarPropostaComDisputa.vue?vue&type=template&id=e93736d4&scoped=true"
import script from "./BotaoCancelarPropostaComDisputa.vue?vue&type=script&lang=js"
export * from "./BotaoCancelarPropostaComDisputa.vue?vue&type=script&lang=js"
import style0 from "./BotaoCancelarPropostaComDisputa.vue?vue&type=style&index=0&id=e93736d4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93736d4",
  null
  
)

export default component.exports